import React, { useState } from 'react';
import { createDataTable } from '@/components/DataTable';
import { SortDirection } from '@/types';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { getOutgoingSmses, MessageStatusFilter, OutgoingSmsLogItem } from '@/services/communicore';
import { Button } from '@ygtechnologies/rubus-ui';
import { DateTimeDisplay, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { MessageStatusCell, StatusFilterSelect } from './shared';
import OutgoingSmsDetailsModal from './OutgoingSmsDetailsModal';
import theme from './Communicore.module.scss';

const DataTable = createDataTable<OutgoingSmsLogItem>();

const OutgoingSmsTable: React.FC = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('createdAt', SortDirection.Descending, 25));
    const [statusFilter, setStatusFilter] = useState<MessageStatusFilter>('');
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [data, , , isLoading] = useAsyncStateWithIsLoading(
        () => getOutgoingSmses(tableState, statusFilter),
        [tableState, statusFilter],
        null
    );

    if (!data) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <DataTable
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                toolbarActions={<StatusFilterSelect value={statusFilter} onChange={setStatusFilter} />}
                className="table style-3">
                <DataTable.Column
                    header="Created"
                    field="createdAt"
                    renderer={(x) => <DateTimeDisplay value={x.value} />}
                />
                <DataTable.Column header="To" field="to" />
                <DataTable.Column
                    header="Body"
                    field="body"
                    renderer={(x) => <span className={theme.truncated}>{x.value}</span>}
                />
                <DataTable.Column
                    header="Status"
                    field="status"
                    renderer={({ row }) => <MessageStatusCell status={row.status} lastError={row.lastError} />}
                />
                <DataTable.Column
                    header="Attempts"
                    field="attemptCount"
                    renderer={({ row }) => `${row.attemptCount} / ${row.maxAttempts}`}
                />
                <DataTable.Column
                    header=""
                    field="id"
                    renderer={({ row }) => (
                        <Button size="xs" variant="tertiary" onClick={() => setSelectedId(row.id)}>
                            Details
                        </Button>
                    )}
                />
            </DataTable>
            {selectedId && <OutgoingSmsDetailsModal id={selectedId} onClose={() => setSelectedId(null)} />}
        </div>
    );
};

export default OutgoingSmsTable;
